/**
 * AetherLite Exercise catalog (público — no requiere auth).
 *
 * Backend: GET /aetherlite/exercises?q=...&muscle=...
 * Devuelve hasta 1408 ejercicios con GIFs animados en español.
 */
import { absUploadUrl, apiFetch } from "./client";

export interface Exercise {
  id: number | string;
  name: string;
  /** Nombre en inglés (el catálogo viene traducido del original ExerciseDB).
   *  Útil para que el buscador acepte términos como "fly", "good morning",
   *  "hack squat" y los matchee a los nombres en español. */
  name_en?: string | null;
  muscle: string;        // "Pecho", "Espalda", "Pierna", "Hombro", "Brazo", "Core", "Cardio", etc.
  equipment?: string | null;
  difficulty?: string | null;
  // El backend de aethercoach devuelve `video_url` (apunta a un .gif animado servido por el CDN).
  // Mantenemos `gif_url` como alias opcional por compat con planes/snapshots viejos.
  video_url?: string | null;
  gif_url?: string | null;
  thumb_url?: string | null;
  description?: string | null;
  instructions?: string | null;
  instructions_en?: string | null;
  secondary_muscles?: string | null;
  // Varios endpoints devuelven aliases; los dejamos opcionales para compat.
  category?: string;
  primary_muscle?: string;
}

/** URL del GIF animado (absolutizada — algunas `video_url` del catálogo son
 *  relativas y romperían en el dominio del link público). */
export function exerciseGifUrl(ex: Exercise): string | null {
  return absUploadUrl(ex.video_url || ex.gif_url) || null;
}

export async function listExercises(query?: string, muscle?: string): Promise<Exercise[]> {
  const params = new URLSearchParams();
  if (query) params.set("q", query);
  if (muscle) params.set("muscle", muscle);
  const qs = params.toString();
  const path = qs ? `/aetherlite/exercises?${qs}` : "/aetherlite/exercises";
  return apiFetch<Exercise[]>(path);
}

/** Devuelve UN ejercicio por id — usado por la página pública /exercise/{id}. */
export async function getExerciseById(id: number | string): Promise<Exercise> {
  return apiFetch<Exercise>(`/aetherlite/exercises/${id}`);
}
